import React from 'react';

import { __t } from '../../../../../base/utils/t';

import { ChipCheckbox } from '../../../../../base/components/Forms/ChipCheckbox';
import { RichTextEditor } from '../../../../../base/components/Forms/RichTextEditor';

import './styles.scss';
import { VACANCY_DESCRIPTION_MAX_LENGTH } from '../../constants';
import { useAppDispatch, useAppSelector } from '../../../../../base/hooks';
import { vacancyFormActions } from '../../redux/slices/vacancyFormSlice';
import { ImageUpload } from '../ImageUpload';
import { LanguageSelectChip } from '../LanguageSelectChip';
import { ConditionsChips } from '../ConditionsChips';
import { Button } from '../../../../../base/components/Button';
import { Icon } from '../../../../../base/components/Icon';

interface Props {
    previewClickHandler: () => void;
}

export const VacancyAdditionalInfoStep = ({ previewClickHandler }: Props) => {
    const dispatch = useAppDispatch();
    const {
        fields: { isExperienceNeeded, isHotVacancy, isPassportOnly, description },
        errors,
    } = useAppSelector((state) => state.vacancyForm);

    const inputChangeHandler = (checked: boolean, id: string) => {
        dispatch(vacancyFormActions.setField({ id, value: checked }));
    };

    const saveDraftClickHandler = () => dispatch(vacancyFormActions.saveDraft());

    return (
        <div className='vacancy-form vacancy-form-step-4'>
            <div className='vacancy-form-step-4__wrapper'>
                <div className='vacancy-form__item'>
                    <p className='vacancy-form-step-4__label'>{__t('Есть ли требования к вакансии?')}</p>
                    <div className='vacancy-form__chips-wrap'>
                        <ChipCheckbox
                            icon='stopwatch-light'
                            text={__t('Нужен работник срочно')}
                            id='isHotVacancy'
                            checked={isHotVacancy}
                            onChange={inputChangeHandler}
                        />
                        <ChipCheckbox
                            icon='person-circle-check-light'
                            text={__t('Возможно без опыта работы')}
                            id='isExperienceNeeded'
                            checked={isExperienceNeeded}
                            onChange={inputChangeHandler}
                        />
                        <ChipCheckbox
                            icon='passport-light'
                            text={__t('Возможно по биометрическому паспорту')}
                            id='isPassportOnly'
                            checked={isPassportOnly}
                            onChange={inputChangeHandler}
                        />
                        <LanguageSelectChip />
                    </div>
                </div>

                <div className='vacancy-form__item'>
                    <p className='vacancy-form-step-4__label'>{__t('Выберите условия, которые предоставляете')}</p>
                    <div className='vacancy-form__chips-wrap'>
                        <ConditionsChips />
                    </div>
                </div>

                <div className='vacancy-form__item'>
                    <p className='vacancy-form-step-4__label'>{__t('Составьте описание к вакансии')}</p>
                    <RichTextEditor
                        initialValue={description}
                        onChange={(value) => dispatch(vacancyFormActions.setField({ id: 'description', value }))}
                        placeholder={`${__t(
                            'К примеру, «Ищу строителя с опытом работы. Строительство односемейных домов. К обязанностям относится укладка кирпича и штукатурка стен.',
                        )}
${__t('Требование:')}
${__t('• умение читать технические рисунки')}
${__t('• наличие водительских прав кат.В.')}
${__t('График работы пн-сб с 8:00 до 17:00.')}`}
                        maxLength={VACANCY_DESCRIPTION_MAX_LENGTH}
                        error={errors?.description}
                    />
                </div>

                <div className='vacancy-form__item'>
                    <ImageUpload />
                </div>

                <Button className='vacancy-form-step-4__preview-button' type='secondary' onClick={previewClickHandler}>
                    <Icon icon='eye-solid' color='danger' className='vacancy-form-footer__button-preview-icon' />
                    {__t('Предварительный просмотр')}
                </Button>

                <Button className='vacancy-form-step-4__preview-button' type='secondary' onClick={saveDraftClickHandler}>
                    {__t('Сохранить черновик')}
                </Button>
            </div>
        </div>
    );
};
